import { Fieldset } from 'primereact/fieldset'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomCheckbox, CustomDropdown, OutlinedBtnPrimary } from '../../../../components'
import { isRouteAllowed } from '../../../../services/permission/menus'
import { SplitButton } from 'primereact/splitbutton'

function EnvioForm({
  onBtnEnviar,
  datasPrevistas,
  onSelecionarTodosClicked,
  onDataPrevistaChange,
  onExportarExcel,
  onGerarPicking,
  onGerarPickingClienteEstoque,
  onGerarPickingReconferencia,
  onGerarRelatorioTotalProdutos,
  onExportarTotalProdutosExcel,
}) {
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [dataPrevista, setDataPrevista] = useState([])

  const onSelecionarTodos = checked => {
    setSelecionarTodos(checked)
    onSelecionarTodosClicked(checked)
  }
  const onDataPrevista = value => {
    setDataPrevista(value)
    setSelecionarTodos(false)
    onDataPrevistaChange(value)
  }

  const splitButtonsItems = [
    {
      label: 'Gerar Picking - Por Cliente-Estoque',
      command: () => onGerarPickingClienteEstoque && onGerarPickingClienteEstoque(),
    },
    {
      label: 'Gerar Picking - Reconferência',
      command: () => onGerarPickingReconferencia && onGerarPickingReconferencia(),
    },
  ]

  const totalProdutosItems = [
    {
      label: 'Exportar em Excel',
      command: () => onExportarTotalProdutosExcel && onExportarTotalProdutosExcel(),
    },
  ]

  return (
    <div>
      <Fieldset legend="Selecione os Veículos para Rota">
        <div className="p-grid">
          <div className="p-col-2" style={{ paddingTop: 30 }}>
            <CustomCheckbox checked={selecionarTodos} onChange={onSelecionarTodos}>
              Selecionar Todos
            </CustomCheckbox>
          </div>
          <div className="p-col-3">
            <CustomDropdown
              marginTop={0}
              label="Filtrar por Data Prevista de Entrega"
              value={dataPrevista}
              options={datasPrevistas}
              onChange={onDataPrevista}
            />
          </div>
          <div className="p-col-12" style={{ paddingTop: 23 }}>
            <Btn onClick={onBtnEnviar}>Enviar Para Rota</Btn>
            <div style={{ display: 'inline-block', marginLeft: 8 }}>
              <OutlinedBtnPrimary label={'Excel - Exportar Dados'} onClick={onExportarExcel} />
            </div>
            {isRouteAllowed(39) && (
              <div style={{ display: 'inline-block', marginLeft: 8 }}>
                <SplitButton
                  menuStyle={{ width: 250 }}
                  className="bck-primary"
                  label="Gerar Picking - Por Cliente"
                  onClick={onGerarPicking}
                  model={splitButtonsItems}
                />
              </div>
            )}
            <div style={{ display: 'inline-block', marginLeft: 8 }}>
              <SplitButton
                menuStyle={{ width: 250 }}
                className="bck-primary"
                label="Relatório Total de Produtos"
                onClick={onGerarRelatorioTotalProdutos}
                model={totalProdutosItems}
              />
            </div>
          </div>
        </div>
      </Fieldset>
    </div>
  )
}

export default connect()(EnvioForm)
